import React, {Component} from "react"
import PropTypes from "prop-types"
import {isEmpty} from "lodash"

import {H2} from "@irati/ui/src/Headings"
import Form from "@irati/ui/src/Form"
import Select from "@irati/ui/src/FormItem/Select"
import HR from "@irati/ui/src/Layout/Hr"
import {injectIntl, FormattedMessage, getResolvedMessage} from "@irati/utils/lang"
import QuantityContainer from "./Quantity/QuantityContainer"
import "./styles/CinemaSelection.css"
import LimitWrapper from "./LimitWrapper"
import SagaStep from "./SagaStep"
import ProductTypes from "../../constants/productTypes"

class CinemaSelection extends Component {
  render() {
    const {
      locations,
      selectedLocation,
      handleChange,
      handleClick,
      selectedProduct,
      deal,
      products,
      formatMessage
    } = this.props
    const options = locations.map((loc) => {
      return {
        value: loc.location,
        label: loc.location,
        disabled: loc.outOfStock
      }
    })

    const optionsReady = isEmpty(options)
    const PLACEHOLDER_TEXT = formatMessage({id: "perks.components.productForms.cinemaSelection.placeholderText"})
    return (
      <div>
        <SagaStep />
        <H2 base>
          <FormattedMessage id="perks.components.productForms.cinemaSelection.title" />
        </H2>
        <LimitWrapper deal={deal} products={products} productType={ProductTypes.CINEMA}>
          <Form>
            <Select
              isDisabled={optionsReady}
              value={getResolvedMessage(this, "selectedLocation")}
              isClearable={false}
              placeholder={optionsReady ? formatMessage({id: "perks.components.productForms.cinemaSelection.loading"}) : PLACEHOLDER_TEXT}
              name="selectedLocation"
              onChange={(value) => handleChange(value)}
              options={options} />
          </Form>
          {selectedLocation && selectedLocation !== PLACEHOLDER_TEXT && (
            <div>
              <HR large />
              <QuantityContainer deal={deal} handleClick={handleClick} products={[selectedProduct]} />
            </div>
          )}
        </LimitWrapper>
      </div>
    )
  }
}

CinemaSelection.defaultProps = {
  selectedLocation: "perks.components.productForms.cinemaSelection.selectedLocation",
  willReachMax: false,
  selectedProduct: null,
  quantity: 0
}

CinemaSelection.propTypes = {
  locations: PropTypes.array.isRequired,
  selectedProduct: PropTypes.object,
  selectedLocation: PropTypes.string,
  handleChange: PropTypes.func.isRequired,
  handleClick: PropTypes.func.isRequired,
  willReachMax: PropTypes.bool,
  deal: PropTypes.object.isRequired,
  formatMessage: PropTypes.func.isRequired,
  products: PropTypes.array.isRequired
}

export default injectIntl(CinemaSelection)
